import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["href"];
import { computed } from 'vue';
import { trlMessage } from '@/services/i18n';
export default /*@__PURE__*/ _defineComponent({
    __name: 'help-link',
    props: {
        email: { default: 'club.support@huntflow.ru' },
        subject: { default: () => (trlMessage('help.subject')) },
        label: { default: () => (trlMessage('help.link')) }
    },
    setup(__props) {
        const link = computed(() => `${__props.email}?subject=${__props.subject}`);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("a", {
                href: `mailto:${link.value}`,
                target: "_blank"
            }, _toDisplayString(__props.label), 9, _hoisted_1));
        };
    }
});
